import React from 'react';

const Empty: React.FC = () => {
  return <div data-cy="device-table-gen1-empty-cell">----</div>;
};

export default Empty;
